import { render, staticRenderFns } from "./Abnormal.vue?vue&type=template&id=ea39836c&scoped=true&"
import script from "./Abnormal.vue?vue&type=script&lang=js&"
export * from "./Abnormal.vue?vue&type=script&lang=js&"
import style0 from "./Abnormal.vue?vue&type=style&index=0&id=ea39836c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea39836c",
  null
  
)

export default component.exports